import { updateContent } from 'app/content/actions';
import type { SagaIterator } from 'redux-saga';
import { race, take } from 'redux-saga/effects';
import { type ActionType, createAction, createReducer } from 'typesafe-actions';

export const NAME = 'contentPreview';
export type SelectedRoute = {
  siteId: string;
  routeName: string;
};

export type ContentPreviewSlice = {
  [NAME]: ContentPreviewState;
};

export type ContentPreviewState = {
  previewRoute?: SelectedRoute;
};

export type IframePayload = {
  contentId: string;
  iframe: HTMLIFrameElement | null;
};

export const setIframe = createAction('content-preview/IFRAME_LOADED')<IframePayload>();
export const setPreviewRoute = createAction('content-preview/SET_PREVIEW_ROUTE')<SelectedRoute | undefined>();

export const closePreview = (): ReturnType<typeof setPreviewRoute> => setPreviewRoute(undefined);

export const reducer = createReducer<ContentPreviewState, ActionType<typeof setPreviewRoute>>({}).handleAction(
  setPreviewRoute,
  (_state, action) => ({
    previewRoute: action.payload
  })
);

export const selectPreviewRoute = (state: ContentPreviewSlice): SelectedRoute | undefined => state[NAME].previewRoute;

export function* saga(): SagaIterator {
  let iframe: HTMLIFrameElement | undefined | null;
  let contentId: string | undefined;
  while (true) {
    const [iframeUpdate, contentUpdated] = yield race([take(setIframe), take(updateContent.fulfilled)]);

    if (iframeUpdate) {
      iframe = iframeUpdate.payload.iframe;
      contentId = iframeUpdate.payload.contentId;
    }

    if (contentUpdated && contentUpdated.meta.contentId === contentId && iframe) {
      // biome-ignore lint/correctness/noSelfAssign: ignore
      iframe.src = iframe.src;
    }
  }
}
